export function formatSwiftBucks (amount) {
  return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}



// WEBPACK FOOTER //
// ./src/lib/format-swiftbucks.js